var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3124 15.0286V37.3342H8.68359V15.0286C8.68359 14.2702 9.29799 13.6558 10.0564 13.6558H37.9444C38.7028 13.6558 39.3124 14.2702 39.3124 15.0286Z",
    fill: "#3C4B59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6719 15.6431H37.3311V33.7343H10.6719V15.6431Z",
    fill: "#F7C680"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4199 11.7215V7.69434H14.0023L17.8183 11.7215H11.4199Z",
    fill: "#F7F7F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0014 11.8943V10.0559C14.0014 8.75034 12.9406 7.69434 11.635 7.69434C10.9822 7.69434 10.3918 7.95834 9.96464 8.38554C9.53744 8.81274 9.27344 9.40314 9.27344 10.0559V11.8943H14.0014Z",
    fill: "#E5E5E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2196 33.7343V10.0607C34.2196 8.75514 33.1588 7.69434 31.8532 7.69434H14.002V33.7343H34.2196Z",
    fill: "#F7F7F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5605 18.0479H31.6613V19.6607H16.5605V18.0479Z",
    fill: "#E5E5E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5605 22.0894H31.6613V23.7022H16.5605V22.0894Z",
    fill: "#E5E5E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5605 26.1265H31.6613V27.7393H16.5605V26.1265Z",
    fill: "#E5E5E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5605 30.168H21.5669V31.7808H16.5605V30.168Z",
    fill: "#E5E5E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2008 35.7217L42.2888 39.3553C42.2888 39.8785 41.8616 40.3057 41.3384 40.3057H6.66798C6.13998 40.3057 5.71278 39.8785 5.71278 39.3505L4.80078 35.7217H19.3352V37.0753H28.6568V35.7217H43.2008Z",
    fill: "#626C78"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M42.288 38.981V39.3554C42.288 39.8834 41.8608 40.301 41.3376 40.301H6.6672C6.1392 40.301 5.7168 39.8786 5.7168 39.3554V38.981C5.7168 39.509 6.144 39.9266 6.6672 39.9266H41.3376C41.8608 39.9266 42.288 39.509 42.288 38.981Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountReview);
export default __webpack_public_path__ + "static/media/account_review.d016c1593da1c2d9e77387d7ebcfd0da.svg";
export { ForwardRef as ReactComponent };